import ChallengesScreen from "@/UI/screens/ChallengesScreen";

export default function ChallengesRoute() {
    return <ChallengesScreen />;
}
